export default "__VITE_ASSET__1e2f5dbe__"